import { BUILDER_HEADER_ID } from '@platform-ui/design-system';

export const ZDS_BUILDER_HEADER = BUILDER_HEADER_ID;
